import { useEffect, useState } from "react";
import PageTitle from "../Helpers/PageTitle";
import Layout from "../Partials/Layout";
import { ErrorToaster, SuccessToaster } from "../Helpers/toaster/Toaster";
import { useLocation, useNavigate } from "react-router-dom";
import AuthServices from "../../apis/auth/AuthServices";
import LoaderStyleOne from "../Helpers/Loaders/LoaderStyleOne";
import VerifyOtp from "../VerifyOtp";

export default function MembershipPlan() {

  const { state } = useLocation()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false);
  const [otpVerificationError, setOtpVerificationError] = useState(false);

  const [openOtpDialog, setOpenOtpDialog] = useState(false);

  const [membershipPlans, setMembershipPlans] = useState([]);
  const [memberShipId, setMemberShipId] = useState();

  const getMembershipPlan = async () => {
    try {
      const { data } = await AuthServices.getMembershipPlan(state?.userType)
      setMembershipPlans(data)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  // *For Send Email OTP
  const sendEmailOtp = async (id) => {
    setLoading(true)
    try {
      let obj = {
        email: state.email,
      }
      await AuthServices.sendEmailOtp(obj)
      setMemberShipId(id)
      setOpenOtpDialog(true)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  // *For Registration
  const registration = async (data) => {
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append("name", state?.name)
      formData.append("username", state?.username)
      formData.append("contact", state?.phone)
      formData.append("whatsapp_number", state?.whatsappNumber)
      formData.append("email", state?.email)
      formData.append("password", state?.password)
      formData.append("password_confirmation", state?.confirmPassword)
      formData.append("cnic", state?.cnic)
      formData.append("user_type", state?.userType)
      formData.append("business_name", state?.businessName)
      formData.append("selling_category", state?.sellingCategory)
      formData.append("brand_name", state?.brandName)
      formData.append("business_contact", state?.businessContact)
      formData.append("ntn_no", state?.ntn)
      formData.append("strn_no", state?.strn)
      formData.append("business_country", state?.businessCountry)
      formData.append("business_city", state?.businessCity)
      formData.append("business_postal_code", state?.businessPostalCode)
      formData.append("business_address", state?.businessAddress)
      formData.append("warehouse_address", state?.warehouseAddress)
      formData.append("membership_plan_id", memberShipId)
      formData.append("cheque_book_slip", state?.chequeBookFile)
      formData.append("fbr_letter", state?.fbrFile)
      formData.append("cnic_front", state?.cnicFrontFile)
      formData.append("cnic_back", state?.cnicBackFile)
      formData.append("account_number", state?.accountNumber)
      formData.append("account_name", state?.accountName)
      formData.append("bank_name", state?.bankName)
      formData.append("iban", state?.iban)
      // formData.append("whatsappverificationcode", data.whatsappOtpCode)
      formData.append("emailverificationcode", data.emailOtpCode)

      // *For Product Images
      state?.productImages.forEach((imageFile, i) => {
        formData.append(`product_images[${i}]`, imageFile)
      });
      // formData.append("card_number", data?.cardNumber)
      // formData.append("card_cvv", data?.cardCvv)
      // formData.append("card_expiry_month", data?.cardMonth)
      // formData.append("card_expiry_year", data?.cardYear)
      const { message } = await AuthServices.register(formData)
      SuccessToaster(message)
      const planName = membershipPlans.find(p => p.id === memberShipId)?.name
      navigate('/register-success', { state: { planName, userType: state?.userType } })
    } catch (error) {
      setOtpVerificationError(true)
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getMembershipPlan()
    window.scrollTo({ top: 0 })
  }, []);

  return (
    <Layout childrenClasses="pt-0 pb-0">

      <VerifyOtp
        loading={loading}
        error={otpVerificationError}
        open={openOtpDialog}
        email={state?.email}
        register={registration}
      />

      <div className="become-saller-wrapper w-full">
        <div className="title mb-10">
          <PageTitle
            title="Membership Plan"
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "membership plan", path: "/membership-plan" },
            ]}
          />
        </div>
        <div className="content-wrapper w-full mb-10">
          <div className="container-x mx-auto">
            <div className="w-full bg-white sm:p-[30px] p-3">
              <div className="flex xl:flex-row flex-col-reverse xl:space-x-11">

                {membershipPlans?.map((item, index) => (
                  <div key={index} className="w-full max-w-sm p-4 bg-white border border-gray-200 rounded-lg shadow sm:p-8">
                    <h5 className="mb-4 text-xl font-medium text-gray-500">{item?.name}</h5>
                    <div className="flex items-baseline text-gray-900">
                      <span className="text-3xl font-semibold">Rs</span>
                      <span className="text-5xl font-extrabold tracking-tight">{item?.price}</span>
                      <span className="ml-1 text-xl font-normal text-gray-500">/{item?.validity}</span>
                    </div>
                    <ul className="space-y-5 my-7">
                      {item?.features.map((feature, i) => (
                        <li key={i} className="flex space-x-3">
                          <svg aria-hidden="true" className="flex-shrink-0 w-5 h-5 text-qblue" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <title>Check icon</title>
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                          </svg>
                          <span className="text-base font-normal leading-tight text-gray-500">{feature?.key}</span>
                        </li>
                      ))}
                    </ul>
                    <button
                      type="button"
                      disabled={loading}
                      onClick={() => sendEmailOtp(item?.id)}
                      className="text-white bgcolor focus:ring-4 focus:outline-none focus:ring-blue-200 font-medium rounded-lg text-sm px-5 py-2.5 inline-flex justify-center w-full h-[50px] text-center items-center"
                    >
                      <span>Choose plan</span>
                      {loading && (
                        <span className="w-5" style={{ transform: "scale(0.3)" }}>
                          <LoaderStyleOne />
                        </span>
                      )}
                    </button>
                  </div>
                ))}

              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
